module.exports = __webpack_public_path__ + "img/20190531172904微信图片_20190531173218.42a39f2b.jpg";